import { useEffect, useState } from 'react';
import axios from 'axios';
import { contactInfo as fbContact, companyInfo as fbCompany, legalInfo as fbLegal, maxBotLink as fbMaxLink } from '../data/mockData';

// Fallback на mockData если API недоступен
const FALLBACK = {
  contact_phone: fbContact?.phone || '+7 918 436-22-55',
  contact_phone_raw: fbContact?.phoneRaw || '79184362255',
  contact_email: fbContact?.email || 'kladoffka24-krd@yandex.ru',
  contact_address_short: fbContact?.address || 'г. Краснодар, мкр Любимово',
  legal_name: fbLegal?.name || 'ООО «Современные решения»',
  legal_inn: fbLegal?.inn || '2308316284',
  legal_ogrn: fbLegal?.ogrn || '1232300047290',
  max_bot_link: fbMaxLink || 'https://max.ru/Kladoffka24bot',
  company_description: fbCompany?.description || 'Современный сервис индивидуального хранения в Краснодаре.',
};

const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';
let _cache = null;
let _inflight = null;

export async function fetchSettings() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API_BASE}/api/settings`)
    .then((r) => {
      _cache = { ...FALLBACK, ...(r.data || {}) };
      return _cache;
    })
    .catch(() => { _cache = FALLBACK; return _cache; })
    .finally(() => { _inflight = null; });
  return _inflight;
}

export default function useSettings() {
  const [items, setItems] = useState(() => _cache || FALLBACK);
  const [loading, setLoading] = useState(() => !_cache);
  useEffect(() => {
    let mounted = true;
    if (!_cache) fetchSettings().then((d) => { if (mounted) { setItems(d); setLoading(false); } });
    else setLoading(false);
    return () => { mounted = false; };
  }, []);
  return { items, loading };
}
